import React, { useId } from 'react';

import { Bloc } from '../../routes/project/components/step-drawer';
import { useRichTextEditor } from '@producer/ui-kit';
import { EditorContent } from '@tiptap/react';

import styles from './text-area-drawer.module.scss';
interface TextAreaDrawerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
}

export const TextAreaDrawer: React.FC<TextAreaDrawerProps> = ({ label, value, onChange }) => {
  const key = useId();

  const { editor } = useRichTextEditor({
    key,
    value,
    onBlur: onChange,
  });

  return (
    <Bloc>
      <label>{label}</label>

      <EditorContent className={styles['input']} editor={editor} />
    </Bloc>
  );
};
